import Moment from "moment";

export function changeTimeZone(date: string, time?: string) {
  const dateNow = new Date().toLocaleString() + "";
  const today = Moment(dateNow).format("YYYY-MM-DD");

  if (date && time) {
    return Moment.tz(`${date} ${time}`, "Asia/Manila").format();
  } else if (!date && !time) {
    return Moment.tz(`${today} 00:00`, "Asia/Manila").format();
  } else if (!date && time) {
    return Moment.tz(`${today} ${time}`, "Asia/Manila").format();
  } else {
    return Moment.tz(`${date} 00:00`, "Asia/Manila").format();
  }
}
